import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import useFeatureFlags from 'hooks/useFeatureFlags';
import ConnectedWelcomeLearnHeader from './WelcomeLearnHeader';
import SearchBox from './SearchBox';
import AskTheExpert from './AskTheExpert';
import Layout from '../shared/Layout';
import CertificationBadges from './CertificationBadges';

const Header = ({ loading }) => {
  const hasUnificationFeatureFlag = useFeatureFlags(
    'readiness-enable-unification',
  );

  if (hasUnificationFeatureFlag) {
    if (loading) return null;
    return (
      <Layout.Main>
        <Layout.Side className="UnificationHeader-hideBelowScreenLg">
          <div />
        </Layout.Side>
        <div className="UnificationHeader-showDivScreenlg" />
        <Layout.Content>
          <div
            data-testid="readiness-enable-unification-search"
            className="UnificationSearchBox"
          >
            <SearchBox
              placeholder={t('learning_library.search.unification_placeholder')}
              unificationFeatureFlag={hasUnificationFeatureFlag}
            />
            <AskTheExpert showSimpleVersion className="mt-8" />
          </div>
          {hasUnificationFeatureFlag && (
            <div className="mt-16 UnificationHeader-showBelowLearnMobile">
              <CertificationBadges />
            </div>
          )}
        </Layout.Content>
      </Layout.Main>
    );
  }
  return <ConnectedWelcomeLearnHeader />;
};

const mapStateToProps = state => ({
  loading: state.loading,
});

// notify the connected Header component of any location changes coming from
// the router. Otherwise, the connected Header will block re-rendering when the
// location changes.
export default withRouter(connect(mapStateToProps)(Header));
